<template>
  <el-dialog
    title="修改报备"
    v-model="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    destroy-on-close
    @close="onClose"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="140px">
      <el-form-item label="公司">{{ item.company }}</el-form-item>
      <el-form-item label="带看项目">{{ item.estateName }}</el-form-item>
      <el-form-item label="报备人"
        >{{ item.consumerName }}/{{ item.consumerMobile }}</el-form-item
      >
      <el-form-item label="报备时间">{{ item.creationTime }}</el-form-item>
      <el-form-item label="客户姓名" prop="clientName">
        <el-col :span="10">
          <el-input v-model="form.clientName" clearable placeholder="请输入客户姓名"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="客户号码" prop="clientMobile">
        <el-col :span="10">
          <el-input v-model="form.clientMobile" clearable></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="客户性别" prop="sex">
        <el-radio-group v-model="form.sex">
          <el-radio label="男" value="男"></el-radio>
          <el-radio label="女" value="女"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="到案人数" prop="dueNum">
        <el-col :span="10">
          <el-input v-model="form.dueNum"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="到案时间" prop="dueTime">
        <el-date-picker v-model="form.dueTime" type="datetime"></el-date-picker>
      </el-form-item>
      <el-form-item label="带看人" prop="daikanName">
        <el-col :span="10">
          <el-input v-model="form.daikanName" clearable></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="带看人手机" prop="daikanMobile">
        <el-col :span="10">
          <el-input v-model="form.daikanMobile" clearable></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="备注" prop="comment">
        <el-col :span="20">
          <el-input v-model="form.comment" type="textarea" clearable></el-input>
        </el-col>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button type="primary" @click="onSubmit" :loading="saving"
        >确定</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      saving: false,
      form: {},
      rules: {
        clientName: [{ required: true, message: "必填", trigger: "blur" }],
        clientMobile: [{ required: true, message: "必填", trigger: "blur" }],
        sex: [{ required: true, message: "必填", trigger: "blur" }],
        dueNum: [{ required: true, message: "必填", trigger: "blur" }],
        dueTime: [{ required: true, message: "必填", trigger: "blur" }],
        daikanName: [{ required: true, message: "必填", trigger: "blur" }],
        daikanMobile: [{ required: true, message: "必填", trigger: "blur" }],
      },
    };
  },
  props: ["item"],
  emits: ["success", "close"],
  watch: {
    item: {
      handler() {
        if (this.item) {
          console.log(this.item);
          this.dialogVisible = true;
          this.form = {
            ...this.item,
          };
          console.log(this.form);
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    /**
     *
     */
    onClose: function () {
      this.$emit("close");
    },

    /**
     * 提交
     */
    onSubmit() {
      if (
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.saving = true;
            this.$http
              .post("admin/v1/reportnew/update", this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success(res.msg);
                  this.$emit("success");
                  this.dialogVisible = false;
                } else {
                  this.$message.danger(res.msg);
                }
              })
              .finally(() => (this.saving = false));
          }
        })
      );
    },
  },
};
</script>

<style scoped></style>
